import { HttpClient, HttpHeaders, HttpParams, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class HttpService {
    constructor(http) {
        this.http = http;
        this._onBehalfOfUser = null;
        this.errorReceived = new Subject();
        this.errorReceived$ = this.errorReceived.asObservable();
    }
    getHeaders(headers) {
        let httpHeaders = {
            'Content-Type': 'application/json',
        };
        if (headers)
            httpHeaders = { ...httpHeaders, ...headers };
        return new HttpHeaders(httpHeaders);
    }
    buildParams(params) {
        let httpParams = new HttpParams();
        for (const key in params) {
            // eslint-disable-next-line no-prototype-builtins
            if (params.hasOwnProperty(key)) {
                httpParams = httpParams.set(key, params[key]);
            }
        }
        return httpParams;
    }
    handleRequest(observable, returnError) {
        return observable.pipe(catchError((error) => {
            console.error('HTTP request error:', error);
            if (returnError) {
                return of(error.error);
            }
            else {
                this.errorReceived.next(error);
            }
            return of();
        }));
    }
    get(apiUrl, headers, params, responseType) {
        const httpHeaders = this.getHeaders(headers);
        const httpParams = this.buildParams(params);
        return this.handleRequest(this.http.get(`${apiUrl}`, {
            headers: httpHeaders,
            params: httpParams,
            responseType: responseType,
        }));
    }
    getWithError(apiUrl, headers, params, responseType) {
        const httpHeaders = this.getHeaders(headers);
        const httpParams = this.buildParams(params);
        return this.handleRequest(this.http.get(`${apiUrl}`, {
            headers: httpHeaders,
            params: httpParams,
            responseType: responseType,
        }), true);
    }
    patch(apiUrl, body, headers, params) {
        const httpHeaders = this.getHeaders(headers);
        const httpParams = this.buildParams(params);
        return this.handleRequest(this.http.patch(`${apiUrl}`, body, {
            headers: httpHeaders,
            params: httpParams,
        }));
    }
    post(apiUrl, body, headers) {
        const httpHeaders = this.getHeaders(headers);
        return this.handleRequest(this.http.post(`${apiUrl}`, body, {
            headers: httpHeaders,
        }));
    }
    postBinary(apiUrl, body) {
        return this.handleRequest(this.http.post(`${apiUrl}`, body, {
            responseType: 'blob',
        }));
    }
    postCase(apiUrl, body) {
        return this.handleRequest(this.http.post(`${apiUrl}`, body));
    }
    putCase(apiUrl, body) {
        return this.handleRequest(this.http.put(`${apiUrl}`, body));
    }
    patchCase(apiUrl, body) {
        return this.handleRequest(this.http.patch(`${apiUrl}`, body));
    }
    postWithError(apiUrl, body) {
        return this.handleRequest(this.http.post(`${apiUrl}`, body), true);
    }
    putWithError(apiUrl, body) {
        return this.handleRequest(this.http.put(`${apiUrl}`, body), true);
    }
    put(apiUrl, body, headers) {
        const httpHeaders = this.getHeaders(headers);
        return this.handleRequest(this.http.put(`${apiUrl}`, body, { headers: httpHeaders }));
    }
    delete(apiUrl, headers) {
        const httpHeaders = this.getHeaders(headers);
        return this.handleRequest(this.http.delete(`${apiUrl}`, { headers: httpHeaders }));
    }
    // Method to update the onBehalfOfUser
    set onBehalfOfUser(user) {
        this._onBehalfOfUser = user;
    }
    // Method to update the onBehalfOfUser
    get onBehalfOfUser() {
        return this._onBehalfOfUser;
    }
    static { this.ɵfac = function HttpService_Factory(t) { return new (t || HttpService)(i0.ɵɵinject(i1.HttpClient)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HttpService, factory: HttpService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], () => [{ type: i1.HttpClient }], null); })();
